import(/* webpackMode: "eager" */ "/vercel/path0/src/app/delete-account/page.tsx");
